
				var addMethods = require("../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["init","search","loadRandomFrame","getStats","loadFrame"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "e71103097da83575c4dc.worker.js", { name: "[fullhash].worker.js" })
					URL.revokeObjectURL(__webpack_public_path__ + "e71103097da83575c4dc.worker.js");
					addMethods(w, methods)
					
					return w
				}
			